export { useBrandNameText } from './useBrandNameText';
